import * as React from 'react';
import { StyledThresholdIndicator } from './ThresholdIndicator.styled';

export interface ThresholdIndicatorProps {
  centerAngle: number;
  thresholdAngle: number;
}

const getOffsetAngleOfRangeCenter = (from: number, to: number) => {
  if (from > to) {
    return (to + (360 - from)) / 2;
  }
  return (to - from) / 2;
};

export const ThresholdIndicator: React.FunctionComponent<ThresholdIndicatorProps> = ({
  centerAngle,
  thresholdAngle,
}) => {
  const fromAngle = 360 - centerAngle - thresholdAngle;
  const toAngle = 360 - centerAngle + thresholdAngle;
  const offset = getOffsetAngleOfRangeCenter(fromAngle, toAngle);

  return (
    <StyledThresholdIndicator $fromAngle={90 + fromAngle} $endAngle={toAngle} $offsetAngleOfCenter={offset}>
      <div className="offsetsSegment left">
        <div className="offsetsSegmentRemove">&nbsp;</div>
      </div>

      <div className="offsetsSegment right">
        <div className="offsetsSegmentRemove">&nbsp;</div>
      </div>
    </StyledThresholdIndicator>
  );
};
